/**
 *  VIDEO
 *  PLAYER
 *
 *  v1.0
 */

class VideoPlayer {

  constructor ( el,videoID, options = {} ) {

    //Bindings
    this.onCanPlayTrough = this.onCanPlayTrough.bind(this);
    this.play = this.play.bind(this);
    this.pause = this.pause.bind(this);
    this.stop = this.stop.bind(this);
    this.mute = this.mute.bind(this);

    this.video = el;
    this.videoID = videoID;
    this.options = options;
    this.canPlayTrough = false;

    this.video.load();

    this.video.addEventListener("canplaythrough", this.onCanPlayTrough);
  }

  onCanPlayTrough() {
    this.canPlayTrough = true;

    if(this.autoplay)
      this.play();
  }

  play() {
    this.video.play();
  }


  pause() {
    this.video.pause();
  }

  stop(){
    this.video.pause();
  }

  mute(){

  }

  destroy () {
    this.video.removeEventListener("canplaythrough", this.onCanPlayTrough);

    this.video = null;
    this.videoID = null;
    this.options = null;
    this.canPlayTrough = null;
  }
}

export default VideoPlayer;
